module.exports = __webpack_public_path__ + "static/axo_burgerbeteiligung_mobilitat-dc1096935ff6e57494f9da5de5afbb89.png";